import {Injectable} from '@angular/core';
import {
  HTTP_INTERCEPTORS,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import {Observable} from 'rxjs';
import {ResponseHandlerService} from "../services/response-handler.service";
import { CookieService } from 'ngx-cookie-service';
import {tap} from "rxjs/operators";
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class AppRequestsInterceptor implements HttpInterceptor {

    constructor(
        private responseHandlerService: ResponseHandlerService,
        private cookieService: CookieService
    ) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (request.url.startsWith(environment.apiUrl)) {
          const token = this.cookieService.get('XSRF-TOKEN');
          request = request.clone({
            setHeaders: {
              'x-xsrf-token': token || '',
            },
            withCredentials: true,
          });
        }
        return next.handle(request).pipe(tap({
            next: httpEvt => httpEvt,
            error: responseError => this.responseHandlerService.handleHttpResponseError(responseError)
        }))
    }
}

export const AppRequestsInterceptorProvider = {
    provide: HTTP_INTERCEPTORS,
    useClass: AppRequestsInterceptor,
    multi: true,
}
